import Robot from './Robot';

export default Robot;
